<template>
  <b-modal
        scrollable
    id="show-edit-documents"
    ref="modal"
    header-class="headerModal"
    centered
    size="lg"
    :title="`${$t('Documents')}: ${orderUnique?.orderNumber}`"
    hide-footer
    @hide="onCancel"
  >
    <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;">
      <div
        v-for="(image, index) in openDocuments"
        :key="index"
      >
        <div
          class="files"
          style="display: flex;align-items: center; gap: 30px;"
        >
          <span style="color: #262E6C; font-weight: bold; width: 100px;">{{ $t("Documents") }}</span>
          <div v-if="getFileExtension(image.fileUrl) === 'pdf' || getFileExtension(image.fileUrl) === 'docx' || getFileExtension(image.fileUrl) === 'xlsm' || getFileExtension(image.fileUrl) === 'xlsx' || getFileExtension(image.fileUrl) === 'plain' || getFileExtension(image.fileUrl) === 'csv'">
            <img
              v-b-tooltip="$t('Document')"
              style="width:30px;height:30px"
              src="../../../assets/images/documentLogo.svg"
            >
            <button
              style="border: 0; width: 48px; height: 36px; background: #FF274F; border-radius: 5px; margin-right: 10px;  margin-left: 22px;"
              @click="downloadFile(image.fileUrl)"
            >
              <b-icon-download style="color: white;" />
            </button>
            <b-icon-x-circle
              style="cursor:pointer"
              @click="deleteFile(image.fileDataId, index)"
            />
          </div>
          <div v-else>
            <img
              v-b-tooltip.hover
              :title="$t('ClickToViewSketchPhoto')"
              class="image"
              style="width: 100px;"
              :src="image.fileUrl"
              alt="Not an image"
              @click.stop="getAllImages(image.fileUrl)"
            >
            <button
              style="border: 0; width: 48px; height: 36px; background: #FF274F; border-radius: 5px; margin-right: 10px;  margin-left: 22px;"
              @click="downloadFile(image.fileUrl)"
            >
              <b-icon-download style="color: white;" />
            </button>
            <b-icon-x-circle
              style="cursor:pointer"
              @click="deleteFile(image.fileDataId, index)"
            />
          </div>
        </div>
      </div>
    </div>
    <div>
      <p
        v-if="openDocuments.length === 0"
        style="color: #FF274F; font-weight: bold;"
      >
        {{ $t('NoImageOrDocument') }}
      </p>
      <AddFile
        ref="addFile1"
        :occasion="'Inventory'"
        :folder="'DeliveryManagementFolder'"
        :label-text="$t('AddFiles')"
        :file-data-type="'Scetch'"
        :file-name="createFileDataDto"
        :file-format="'fourthFormat'"
      />
      <div class="buttonsEverywhere">
        <b-button
          type="button"
          variant="none"
          class="buttonSubmit"

          @click="onSubmit"
        >
          {{ $t('Submit') }}
        </b-button>
        <b-button
          type="button"
          variant="danger"
          class="buttonCancel"
          @click="onCancel"
        >
          {{ $t('Cancel') }}
        </b-button>
      </div>
    </div>
    <vue-easy-lightbox
      :esc-disabled="false"
      :visible="image.visible"
      :imgs="image.imgs"
      :index="image.index"
      @hide="handleHide"
    />
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VueEasyLightbox from 'vue-easy-lightbox'
import AddFile from '@/modals/AddFile.vue';


export default {
  components: {
    VueEasyLightbox,
    AddFile,
  },
  props: ['openDocuments', 'orderUnique'],
  data() {
    return {
      image: {
        zoom: 1,
        imgs: [],
        visible: false,
        index: 0,
      },
      createFileDataDto: [],
    }
  },
  computed: {
    ...mapGetters([]),
  },
  mounted() {

  },
  methods: {
    ...mapActions(['deleteFileInventory']),
    deleteFile(photo, index) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this photo?', {
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Delete',
        cancelTitle: 'Cancel',
        cancelVariant: 'none',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      })
        .then((value) => {
          if (value) {
            this.deleteFileInventory({
              fileDataId: photo,
              successCallback: () => {
                this.$emit('updateList')
                this.openDocuments.splice(index, 1);
              },
            });
          }
        })
        .catch((err) => {
          console.log('Error in msgBoxConfirm:', err);
        });
    },
    getFileExtension(url) {
      try {
        const pathname = new URL(url).pathname;
        return pathname.split('.').pop().toLowerCase();
      } catch (e) {
        return '';
      }
    },
    downloadFile(fileUrl) {
      window.open(fileUrl, '_blank');
    },
    async getAllImages(item) {
      this.image.imgs = [];
      this.image.imgs.push({
        src: item,
      })
      this.show();
    },
    show() {
      this.image.visible = true
    },
    handleHide() {
      this.image.visible = false
      this.image.imgs.length = []
    },
    async onSubmit() {
      await this.$refs.addFile1.uploadFile();
      const fileObjects = this.createFileDataDto.map((filePath) => {
        return {
          deliveryManagementId: this.orderUnique.id,
          fileUrl: filePath,
        }
      });
      if (this.createFileDataDto.length > 0) {
        this.$emit('addFilesDeliveryModal', fileObjects);
      }
      this.$refs.modal.hide()
      this.onReset()
    },
    onCancel() {
      this.$refs.modal.hide()
    },
    onReset() {
      this.createFileDataDto = []
    },
  },
}
</script>

<style lang="scss" scoped>
.files{
  display: flex;
  flex-direction: row;
  margin: 10px auto;
  background-color: rgb(207, 207, 207);
  border: none;
  box-shadow: none;
  padding: 12px;
  color: #212529;
  border-radius: 8px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.image {
  cursor: pointer;
}
</style>
